import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Message} from 'src/app/core/class/message';
import {CommonService} from 'src/app/core/services/common.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'dowload-app-vneid-mobile',
  templateUrl: './dowload-app-vneid-mobile.component.html',
  styleUrls: ['./dowload-app-vneid-mobile.component.scss']
})
export class DowloadAppVNeIDMobileComponent extends BaseComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DowloadAppVNeIDMobileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.cancel();
    });
  }

  urlDowloadMysign: string = 'https://play.google.com/store/apps/details?id=com.vnid';
  urlAppstoreMysign: string = 'https://apps.apple.com/vn/app/vneid/id1582750372';
  urlChPlayMysign: string = 'https://play.google.com/store/apps/details?id=com.vnid';
  copyLink() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.urlDowloadMysign).then(() => {
        this.toastr.success(
          this.message.getMessage("app_mobile.link_copied")
        );
      }).catch((error) => {
        console.error('Lỗi khi sao chép đường dẫn:', error);
      });
    } else {
      this.unsecuredCopyToClipboard(this.urlDowloadMysign);
    }
  }

  changeLinkStore(typeStore:string) {
    if (typeStore == 'AppStore') {
      window.open(this.urlAppstoreMysign, '_blank');
    } else {
      window.open(this.urlChPlayMysign, '_blank');
    }
    
  }

  unsecuredCopyToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      this.toastr.success(
        this.message.getMessage("app_mobile.link_copied")
      );
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  /**
   * Close pop-up
   */
  cancel() {
    this.dialogRef.close();
  }
}
